import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { login, register, sendVerificationCode, setPassword } from '../utils/authManager';

export default function AuthPage() {
  const [isLogin, setIsLogin] = useState(true);
  const [registerStep, setRegisterStep] = useState(1); // 1: 邮箱+验证码, 2: 设置密码
  
  // 表单数据
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [password, setPasswordValue] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [nickname, setNickname] = useState('');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [codeBtnText, setCodeBtnText] = useState('获取验证码');
  const [codeBtnDisabled, setCodeBtnDisabled] = useState(false);
  const [devCode, setDevCode] = useState(''); // 开发模式验证码
  
  const navigate = useNavigate();

  // 获取验证码
  const handleSendCode = () => {
    if (!email || !email.includes('@')) {
      setMessage('请输入正确的邮箱地址');
      setMessageType('error');
      return;
    }
    
    const result = sendVerificationCode(email);
    setMessage(result.message);
    setMessageType(result.success ? 'success' : 'error');
    
    if (result.success) {
      // 开发模式：显示验证码
      if (result.devCode) {
        setDevCode(result.devCode);
      }
      
      // 倒计时
      setCodeBtnDisabled(true);
      let count = 60;
      setCodeBtnText(`重新发送(${count}s)`);
      const timer = setInterval(() => {
        count--;
        if (count <= 0) {
          clearInterval(timer);
          setCodeBtnText('获取验证码');
          setCodeBtnDisabled(false);
        } else {
          setCodeBtnText(`重新发送(${count}s)`);
        }
      }, 1000);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (isLogin) {
      // 登录逻辑
      const result = login(email, password);
      setMessage(result.message);
      setMessageType(result.success ? 'success' : 'error');
      
      if (result.success) {
        setTimeout(() => {
          navigate('/');
        }, 1000);
      }
    } else {
      // 注册逻辑
      if (registerStep === 1) {
        // 第一步：验证邮箱和验证码
        const result = register(email, code, null, nickname);
        setMessage(result.message);
        setMessageType(result.success ? 'success' : 'error');
        
        if (result.success) {
          setRegisterStep(2);
        }
      } else {
        // 第二步：设置密码
        if (password !== confirmPassword) {
          setMessage('两次输入的密码不一致');
          setMessageType('error');
          return;
        }
        
        if (password.length < 6) {
          setMessage('密码长度至少6位');
          setMessageType('error');
          return;
        }
        
        const user = JSON.parse(localStorage.getItem('currentUser'));
        const result = setPassword(user.id, password);
        setMessage(result.message);
        setMessageType(result.success ? 'success' : 'error');
        
        if (result.success) {
          setTimeout(() => {
            navigate('/');
          }, 1000);
        }
      }
    }
  };

  return (
    <div className="auth-container">
      {/* 顶部导航栏 */}
      <header className="app-header">
        <div className="header-left">
          <div className="logo">
            <span className="logo-icon">✈️</span>
            <div>
              <h1>智伴精读</h1>
              <p className="logo-subtitle">AEN 五维一体 · 外刊精读</p>
            </div>
          </div>
        </div>
        <nav className="header-nav">
          <Link to="/" className="nav-link">首页</Link>
          <Link to="/subscription" className="nav-link">订阅中心</Link>
        </nav>
      </header>

      {/* 登录/注册表单 */}
      <div className="auth-content">
        <div className="auth-card">
          <div className="auth-header">
            <h2>{isLogin ? '🔐 登录' : '📝 注册'}</h2>
            <p>{isLogin ? '欢迎回来！请登录您的账户' : '创建新账户，开始学习之旅'}</p>
          </div>

          {message && (
            <div className={`auth-message ${messageType}`}>
              {message}
            </div>
          )}

          <form onSubmit={handleSubmit} className="auth-form">
            {/* 登录表单 */}
            {isLogin && (
              <>
                <div className="form-group">
                  <label>邮箱地址</label>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="请输入邮箱"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>密码</label>
                  <input
                    type="password"
                    value={password}
                    onChange={(e) => setPasswordValue(e.target.value)}
                    placeholder="请输入密码"
                    required
                  />
                </div>
              </>
            )}

            {/* 注册 - 第一步：邮箱+验证码 */}
            {!isLogin && registerStep === 1 && (
              <>
                <div className="form-group">
                  <label>邮箱地址</label>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="请输入邮箱"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>验证码</label>
                  <div style={{ display: 'flex', gap: '10px' }}>
                    <input
                      type="text"
                      value={code}
                      onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                      placeholder="请输入验证码"
                      required
                      style={{ flex: 1 }}
                    />
                    <button
                      type="button"
                      className="btn btn-outline"
                      onClick={handleSendCode}
                      disabled={codeBtnDisabled}
                    >
                      {codeBtnText}
                    </button>
                  </div>
                  {devCode && (
                    <p style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                      💡 开发模式验证码：<strong style={{ color: '#1976d2' }}>{devCode}</strong>
                    </p>
                  )}
                </div>
                <div className="form-group">
                  <label>昵称（可选）</label>
                  <input
                    type="text"
                    value={nickname}
                    onChange={(e) => setNickname(e.target.value)}
                    placeholder="请输入昵称"
                  />
                </div>
              </>
            )}

            {/* 注册 - 第二步：设置密码 */}
            {!isLogin && registerStep === 2 && (
              <>
                <div className="form-group">
                  <label>设置密码</label>
                  <input
                    type="password"
                    value={password}
                    onChange={(e) => setPasswordValue(e.target.value)}
                    placeholder="请设置登录密码（至少6位）"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>确认密码</label>
                  <input
                    type="password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    placeholder="请再次输入密码"
                    required
                  />
                </div>
              </>
            )}

            {!isLogin && registerStep === 1 && (
              <div className="form-group terms-checkbox">
                <label>
                  <input type="checkbox" required />
                  我已阅读并同意
                  <Link to="/privacy" target="_blank" className="terms-link">《隐私政策》</Link>
                  和
                  <Link to="/terms" target="_blank" className="terms-link">《用户服务协议》</Link>
                </label>
              </div>
            )}
            <button type="submit" className="btn btn-primary btn-block">
              {isLogin ? '登录' : (registerStep === 1 ? '验证并注册' : '完成注册')}
            </button>
          </form>

          {/* 注册步骤导航 */}
          {!isLogin && registerStep === 2 && (
            <div className="auth-switch">
              <button onClick={() => setRegisterStep(1)} className="link-btn">
                ← 返回上一步
              </button>
            </div>
          )}

          <div className="auth-switch">
            {isLogin ? (
              <p>
                还没有账户？{' '}
                <button onClick={() => { setIsLogin(false); setRegisterStep(1); setDevCode(''); }} className="link-btn">
                  立即注册
                </button>
              </p>
            ) : (
              <p>
                已有账户？{' '}
                <button onClick={() => setIsLogin(true)} className="link-btn">
                  立即登录
                </button>
              </p>
            )}
          </div>

          {/* {isLogin && (
            <div className="test-account">
              <p>🔑 免费试用测试账户：</p>
              <p>邮箱：test@aenedu.site</p>
              <p>密码：123456</p>
              <p style={{ marginTop: '12px', paddingTop: '12px', borderTop: '1px solid #eee' }}>⭐ VIP订阅测试账户：</p>
              <p>邮箱：vip@aenedu.site</p>
              <p>密码：123456</p>
            </div>
          )} */}
        </div>
      </div>

      {/* 页脚 */}
      <footer className="app-footer">
        <div className="footer-content">
          <div className="footer-section">
            <h4>✈️ 智伴英航教育</h4>
            <p>专注于K12英语教育，提供全方位的学习解决方案</p>
          </div>
          <div className="footer-section">
            <h4>📞 联系方式</h4>
            <p>电话：187-8306-7878</p>
            <p>邮箱：aenedu.site@gmail.com</p>
            <p>地址：上海市 · 松江区 · 九亭镇</p>
          </div>
          <div className="footer-section">
            <h4>🔗 快速链接</h4>
            <Link to="/">首页</Link>
            <Link to="/subscription">订阅中心</Link>
            <Link to="/privacy">隐私政策</Link>
            <Link to="/terms">用户协议</Link>
          </div>
        </div>
        <div className="footer-copyright">
          © 2026 智伴英航教育科技有限公司 版权所有
        </div>
      </footer>
    </div>
  );
}